import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { IconButton_IconSizes } from '@ydistri/ds';
import { COLORS, computeRemSize } from '@ydistri/theme';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const SharingState = styled.span`
  align-items: center;
  display: inline-flex;
  flex: 0 0 ${computeRemSize(24)};
  justify-content: center;
`;

interface ScopeSharingIconProps {
  color?: CSSProperties['color'];
  isShared: boolean;
  label?: string;
  showTooltip?: boolean;
  size?: CSSProperties['fontSize'];
}

const ScopeSharingIcon: React.FC<ScopeSharingIconProps> = ({
  color,
  isShared,
  label = isShared ? 'Shared Scope' : 'Local Scope',
  showTooltip = true,
  size = IconButton_IconSizes.small,
}) => {
  const iconStyle = {
    color: color ?? (isShared ? COLORS.PRIMARY : COLORS.GREY),
    fontSize: size,
  };
  const icon = isShared ? (
    <EyeOutlined style={iconStyle} />
  ) : (
    <EyeInvisibleOutlined style={iconStyle} />
  );
  const content = (
    <SharingState
      aria-label={label}
      data-scope-sharing={isShared ? 'shared' : 'local'}
      title={label}
    >
      {icon}
    </SharingState>
  );

  return showTooltip ? <Popover content={label}>{content}</Popover> : content;
};

export default ScopeSharingIcon;
